<template>
  <div v-if="pagesCount > 1" ref="rootRef">
    <ul class="pagination">
      <template v-if="currPage !== 1">
        <li class="page-item" @click.prevent="changePage(1)">
          <a class="page-link" href="JavaScript:Void(0);"><span>|&lt;</span></a>
        </li>
        <li class="page-item" @click.prevent="changePage(currPage - 1)">
          <a class="page-link" href="JavaScript:Void(0);"><span>&lt; </span></a>
        </li>
      </template>
      <li
        v-for="n in maxLinkBoxx"
        :class="[{ active: startPage + n - 1 === currPage }, 'page-item']"
        :key="n"
        @click.prevent="changePage(startPage + n - 1)"
      >
        <a class="page-link" href="JavaScript:Void(0);"
          ><span>{{ startPage + n - 1 }}</span></a
        >
      </li>

      <template v-if="currPage !== pagesCount">
        <li class="page-item" @click.prevent="changePage(currPage + 1)">
          <a class="page-link" href="JavaScript:Void(0);"><span>></span></a>
        </li>

        <li class="page-item" @click.prevent="changePage(pagesCount)">
          <a class="page-link" href="JavaScript:Void(0);"><span>>|</span></a>
        </li>
      </template>
    </ul>
  </div>
</template>

<script setup>
import { ref, computed, nextTick } from "vue";

const props = defineProps({
  recordsCount: {
    type: Number,
    required: true,
  },
  perPage: {
    type: Number,
    default: 10,
  },
  currPage: {
    type: Number,
    default: 1,
  },
});

const emit = defineEmits(['pageChange']);

const rootRef = ref(null);

// Data
const maxLinkBox = ref(5);
const maxBoxLeftSide = ref(4);

// Computed
const pagesCount = computed(() => {
  return Math.ceil(props.recordsCount / props.perPage);
});

const maxLinkBoxx = computed(() => {
  return Math.min(pagesCount.value, maxLinkBox.value);
});

const startPage = computed(() => {
  let startPage = props.currPage - maxBoxLeftSide.value;

  if (startPage < 1) {
    return 1;
  }

  const endPage = startPage - 1 + maxLinkBoxx.value;
  if (endPage > pagesCount.value) {
    startPage = startPage - (endPage - pagesCount.value);
  }

  if (startPage < 1) {
    return 1;
  }

  return startPage;
});

const getHeaderOffset = () => {
  const header = document.querySelector('header');
  return (header?.offsetHeight ?? 0) + 8;
};

const getListSection = (el) => {
  return (
    el.closest('.products-disabled')
    || el.closest('.review-container')
    || el.closest('.products-wrapper')
    || el.closest('.flower-library-content-wrapper')
    || el.closest('.col-lg-10')
    || el.closest('.container-fluid')
  );
};

const getScrollTarget = (paginationEl) => {
  const tableControls = paginationEl.closest('.table-controls-wrapper');
  if (tableControls) return tableControls;

  const section = getListSection(paginationEl);
  if (section) {
    const topTableControls = section.querySelector('.table-controls-wrapper');
    if (topTableControls) return topTableControls;

    const firstPaginationRoot = section.querySelector('ul.pagination')?.parentElement;
    if (firstPaginationRoot) return firstPaginationRoot;
  }

  return paginationEl;
};

const scrollToPaginationStart = () => {
  const element = rootRef.value;
  if (!element) return;

  const scrollTarget = getScrollTarget(element);
  const headerOffset = getHeaderOffset();
  const top = scrollTarget.getBoundingClientRect().top + window.scrollY - headerOffset;

  window.scrollTo({
    top: Math.max(0, top),
    behavior: 'smooth',
  });
};

// Methods
const changePage = (pageNumb) => {
  emit("pageChange", pageNumb);

  nextTick(() => {
    requestAnimationFrame(scrollToPaginationStart);
  });
};
</script>
<style scoped>
ul.pagination {
  float: right;
}
</style>
